import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { GetSubscriptionsParams, SubscriptionsSchema } from './types';
import { SubscriptionsService } from '../services';

const IDLE = 'idle' as const;

const initialState: SubscriptionsSchema = {
  hasFeatureEnabled: {
    data: null,
    status: IDLE,
  },
  subscriptionsList: {
    data: null,
    status: IDLE,
  },
};

export const hasFeatureEnabledAction = createAsyncThunk(
  'subscriptions/hasFeatureEnabledAction',
  async () => await SubscriptionsService.hasFeatureEnabled(),
);

export const getSubscriptionsAction = createAsyncThunk(
  'subscriptions/getSubscriptionsAction',
  async (params?: GetSubscriptionsParams) =>
    await SubscriptionsService.getSubscriptions(params),
);

const subscriptionsSlice = createSlice({
  name: 'subscriptions',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(hasFeatureEnabledAction.pending, (state) => {
        state.hasFeatureEnabled.status = 'loading';
      })
      .addCase(hasFeatureEnabledAction.fulfilled, (state, action) => {
        state.hasFeatureEnabled.data = action.payload;
        state.hasFeatureEnabled.status = 'success';
      })
      .addCase(hasFeatureEnabledAction.rejected, (state) => {
        state.hasFeatureEnabled.status = 'error';
      })
      .addCase(getSubscriptionsAction.pending, (state) => {
        state.subscriptionsList.status = 'loading';
      })
      .addCase(getSubscriptionsAction.fulfilled, (state, action) => {
        state.subscriptionsList.data = action.payload;
        state.subscriptionsList.status = 'success';
      })
      .addCase(getSubscriptionsAction.rejected, (state) => {
        state.subscriptionsList.status = 'error';
      });
  },
});

export const { reducer } = subscriptionsSlice;
